import { types } from '../types/types';

const initialState = {
  permissions: null,
  loading: false,
  error: null
};

export const permissionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.PERMISSIONS_LOADING:
      return { ...state, loading: true, error: null };
    case types.PERMISSIONS_SUCCESS:
      return { ...state, loading: false, permissions: action.payload, error: null };
    case types.PERMISSIONS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case types.PERMISSIONS_CLEAR:
      return { ...initialState };
    default:
      return state;
  }
};
